export const DESIGNATION_FIELD_NAMES = {
  headOfHousehold: 'headOfHousehold',
};
